import { getStorage, ref, getDownloadURL } from "firebase/storage";

export const getDownloadUrl = async (path) => {
	const storage = getStorage();

	const fileRef = ref(storage, path);

	const url = await getDownloadURL(fileRef);

	return url;
};
